import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { clearThinkEducationSurveyClosed } from '@/utils/think-education-survey';

export const USER_INFO_STORAGE_KEY = 'user-info';

interface UserDetails {
  id?: string | number;
  email: string;
  first_name: string;
  last_name: string;
  // Add any other user properties you need
}

interface UserState {
  user: UserDetails | null;
  displayFirstName: string | null;
  displayLastName: string | null;
  setUser: (user: UserDetails) => void;
  setDisplayFirstName: (firstName: string | null) => void;
  setDisplayLastName: (lastName: string | null) => void;
  clearUser: () => void;
  realtimeAudioEnabled: boolean;
  hasAdminPermissions: boolean;
  setRealtimeAudioEnabled: (mode: boolean) => void;
  setHasAdminPermissions: (hasPermissions: boolean) => void;
  hasSuperAdminPermissions: boolean;
  setHasSuperAdminPermissions: (hasPermissions: boolean) => void;
  hasAcceptedDisclaimer: boolean;
  setHasAcceptedDisclaimer: (hasAccepted: boolean) => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      displayFirstName: null,
      displayLastName: null,
      setUser: (user) => set({ user }),
      setDisplayFirstName: (displayFirstName) => set({ displayFirstName }),
      setDisplayLastName: (displayLastName) => set({ displayLastName }),
      realtimeAudioEnabled: false,
      setRealtimeAudioEnabled: (value: boolean) =>
        set({ realtimeAudioEnabled: value }),
      clearUser: () => {
        clearThinkEducationSurveyClosed();
        set({
          user: null,
          displayFirstName: null,
          displayLastName: null,
          hasAcceptedDisclaimer: false,
          hasAdminPermissions: false,
          hasSuperAdminPermissions: false,
          realtimeAudioEnabled: false,
        });
      },
      hasAdminPermissions: false,
      // TODO: probably we should move this into one permissions object - {hasAdminPermissions: boolean, hasSuperAdminPermissions: boolean}
      setHasAdminPermissions: (hasAdminPermissions: boolean) =>
        set({ hasAdminPermissions }),
      hasSuperAdminPermissions: false,
      setHasSuperAdminPermissions: (hasSuperAdminPermissions: boolean) =>
        set({ hasSuperAdminPermissions }),
      hasAcceptedDisclaimer: false,
      setHasAcceptedDisclaimer: (hasAcceptedDisclaimer: boolean) =>
        set({ hasAcceptedDisclaimer }),
    }),
    { name: USER_INFO_STORAGE_KEY }
  )
);
